import type { ICellRendererParams, SortModelItem } from 'ag-grid-community';

import PriorityChip, { type PriorityTypes } from '@/components/PriorityChip';
import { dateTimeRenderer } from '@/utils/GridRenderer.utils';

import {
  ticketsAssigneeRenderer,
  ticketsAuthorRenderer,
  ticketsCategoryRenderer,
  ticketsOwnerRenderer,
  ticketsStatusRenderer
} from './TicketsTable.utils';

export const getTicketColumnDefs = (userIsInternal: boolean) => [
  {
    field: 'id',
    headerName: 'ID',
    headerTooltip: 'ID',
    maxWidth: 100,
    minWidth: 70,
    sortable: true
  },
  {
    field: 'ticket_status_id',
    headerName: 'Status',
    cellRenderer: ticketsStatusRenderer,
    width: 120
  },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    minWidth: 250
  },
  {
    field: 'priority_id',
    headerName: 'Priority',
    cellRenderer: (params: ICellRendererParams) => (
      <PriorityChip priority={params.data.priority_name as PriorityTypes} />
    ),
    width: 90
  },
  {
    field: 'ticket_category__name',
    headerName: 'Category',
    cellRenderer: ticketsCategoryRenderer,
    width: 180
  },
  {
    field: 'published_at',
    headerName: 'Created',
    cellRenderer: dateTimeRenderer,
    width: 170
  },
  {
    field: 'updated_at',
    headerName: 'Last Updated',
    cellRenderer: dateTimeRenderer,
    width: 170
  },
  {
    field: 'followup_date',
    headerName: 'Follow-Up',
    cellRenderer: dateTimeRenderer,
    width: 170,
    hide: !userIsInternal
  },
  {
    field: 'owner__name',
    headerName: 'Owner',
    cellRenderer: ticketsOwnerRenderer,
    width: 120,
    hide: !userIsInternal
  },
  {
    field: 'user__name',
    headerName: 'Author',
    cellRenderer: (params: ICellRendererParams) =>
      ticketsAuthorRenderer(params, userIsInternal),
    width: 150
  },
  {
    field: 'assignee__name',
    headerName: 'Assignee',
    cellRenderer: ticketsAssigneeRenderer,
    width: 120
  },
  {
    field: 'organization_name',
    headerName: 'Organization',
    width: 200
  },
  {
    field: 'alert_source',
    headerName: 'Alert Source',
    width: 180,
    hide: !userIsInternal
  }
];

export const TICKETS_TABLE_DEFAULT_SORT_MODEL: SortModelItem[] = [
  {
    colId: 'id',
    sort: 'desc'
  }
];

export default getTicketColumnDefs;
